import getElementAttribute from '../accessors/get-element-attribute';
import DEFAULT_OPTIONS from '../constants/default-options';
import setElementAttribute from './set-element-attribute';
import constants from '../../css-generator/constants';

const { BREAKPOINT_ORDER } = constants;

function sortResponsiveValues(values) {
  return values.slice().sort((a, b) => {
    const getBp = (val) => {
      const index = val.indexOf(':');
      return index === -1 ? '' : val.slice(0, index);
    };
    return BREAKPOINT_ORDER.indexOf(getBp(a)) - BREAKPOINT_ORDER.indexOf(getBp(b));
  });
}

const setResponsiveAttribute = (elementId, attr, value, breakpoint, options = DEFAULT_OPTIONS) => {
  const newValue = breakpoint ? `${breakpoint}:${value}` : value;
  const regExp = new RegExp(`\\b${breakpoint}:[^\\s]+\\b`, 'g');
  const attrValue = getElementAttribute(elementId, attr) || '';

  const filteredValueArr = attrValue.split(' ').filter((val) => {
    if (!val) return false;

    if (breakpoint) {
      return !regExp.test(val);
    }

    return val.contains(':');
  });
  filteredValueArr.push(newValue);
  const responsiveValue = sortResponsiveValues(filteredValueArr).join(' ');

  return setElementAttribute(elementId, attr, responsiveValue, options);
};

export default setResponsiveAttribute;
